import React from 'react';
import { FilterRendererProps } from '../../DataTable.types';
import { Button } from '../../../';
import styles from './FilterRenderer.module.scss';
import MultiSelectSearchDropdown from '../../../../ManageDealDrawer/Components/MultiSelectSearchDropdown/MultiSelectSearchDropdown';
import closeIcon from '../../../SideDrawer/close.svg';
import { CLEAR_FILTER_BUTTON_STYLE } from './clearFilterButtonStyle';
export const MultiSelectFilterRenderer: React.FC<FilterRendererProps> = ({ column, value, onChange, options }) => {
    // Ensure value is always an array to prevent controlled/uncontrolled input warnings
    const safeValue = Array.isArray(value) ? value : [];
    const isApplied = safeValue.length > 0;

    const handleClear = (e: React.MouseEvent) => {
        e.preventDefault();
        onChange([]);
    };

    const handleToggleSelection = (selectedOptions: (string | null)[]) => {
        // Ensure we always pass an array
        onChange(Array.isArray(selectedOptions) ? selectedOptions : []);
    };

    return (
        <div className={styles.FilterRenderer}>
            <div className={isApplied ? styles.FilterApplied : styles.FilterContainer}>
                <div className={styles.FilterRow}>
                    <div className={styles.FilterLabel}>{column?.filterConfig?.label || column.headerLabel}</div>
                    <div className={styles.FilterDropdown}>
                        <MultiSelectSearchDropdown
                            options={options || []}
                            selectedItems={safeValue}
                            placeholder={'All'}
                            toggleSelection={handleToggleSelection}
                        />
                    </div>
                    {isApplied && (
                        <Button
                            text=""
                            icon={closeIcon}
                            type="reset"
                            onClick={handleClear}
                            variant="white"
                            style={CLEAR_FILTER_BUTTON_STYLE}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
